import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'

const whiteList = ['/login'] // 白名单

router.beforeEach((to, from, next) => {
  NProgress.start()

  if (getToken()) {
    // 已登录
    if (to.path === '/login') {
      // 访问登录页 → 跳首页
      next({ path: '/' })
      NProgress.done()
    } else {
      // 直接放行，不判断角色、不加载动态路由
      next()
    }
  } else {
    // 未登录
    if (whiteList.includes(to.path)) {
      next()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})


// WEBPACK FOOTER //
// ./src/permission.js